// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { GlobalValidator } from "../../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const btcbech32: GlobalValidator = createValidator(
  "crypto.btcbech32",
  42,
);

export default btcbech32;
export const compact = btcbech32.compact;
export const format = btcbech32.format;
export const validate = btcbech32.validate;
export const convertBits = (
  values: readonly number[],
  fromBits: number,
  toBits: number,
): number[] | null =>
  getBinding().convertBits(values, fromBits, toBits);
export const polymod = (
  values: readonly number[],
): number => getBinding().polymod(values);
export const validateBech32 = (
  value: string,
):
  | { valid: true }
  | {
      valid: false;
      code: "format" | "checksum" | "component";
    } => getBinding().validateBech32(value);
